<template>
  <ValidationObserver ref="observer">
    <v-form @submit="handleAssignmentBox">
      <div style="margin-bottom: 40px">
        <GenericTitle :title="titleForm" center />
      </div>
      <div>
        <ValidationProvider v-slot="{ errors }" name="Sede" rules="required">
          <SelectInput
            class="mb-4"
            v-model="form.headquarter"
            :items="headquarters"
            label="Sede"
            item-value="headquartersCode"
            item-text="headquartersName"
            outlined
            dense
            :error-messages="errors"
          />
        </ValidationProvider>
        <ValidationProvider v-slot="{ errors }" name="Box" rules="required">
          <SelectInput
            class="mb-4"
            v-model="form.box"
            :items="boxes"
            label="Box"
            item-value="boxCode"
            item-text="boxDetail"
            outlined
            dense
            :error-messages="errors"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Tipos de prioridad"
          rules="required"
        >
          <SelectInput
            class="mb-4"
            v-model="form.priority"
            :items="priorityTypes"
            label="Tipos de prioridad"
            item-value="priorityCode"
            item-text="priorityName"
            outlined
            multiple
            chips
            :error-messages="errors"
          />
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          name="Colas de atención"
          rules="required"
        >
          <SelectInput
            class="mb-4"
            v-model="form.attentionQueue"
            :items="attentionQueues"
            label="Colas de atención"
            item-value="attentionQueueCode"
            item-text="attentionQueueName"
            outlined
            multiple
            chips
            :error-messages="errors"
          />
        </ValidationProvider>
        <BasicButton
          color="primary"
          type="submit"
          :loading="loading"
          text="Asignar"
        />
      </div>
    </v-form>
  </ValidationObserver>
</template>

<script>
import GenericTitle from '@/infrastructure/vue/components/common/titles/GenericTitle';
import SelectInput from '@/infrastructure/vue/components/common/inputs/SelectInput';
import BasicButton from '@/infrastructure/vue/components/common/buttons/BasicButton';
import { required } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'El campo {_field_} es obligatorio',
});
export default {
  name: 'AssignBoxForm',
  components: {
    GenericTitle,
    SelectInput,
    BasicButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    titleForm: {
      type: String,
      default: '',
    },
    headquarters: {
      type: Array,
      default: () => [],
    },
    boxes: {
      type: Array,
      default: () => [],
    },
    priorityTypes: {
      type: Array,
      default: () => [],
    },
    attentionQueues: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    formFieldsDefault: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    form: {
      headquarter: null,
      box: null,
      priority: null,
      attentionQueue: null,
    },
  }),
  watch: {
    formFieldsDefault(nuevo) {
      this.form = nuevo;
    },
  },

  methods: {
    async handleAssignmentBox(e) {
      e.preventDefault();
      const isValidateForm = await this.$refs.observer.validate();
      if (isValidateForm) {
        const selectHeadquarters = this.headquarters.find(
          (headquarter) =>
            headquarter.headquartersCode === this.form.headquarter
        );
        this.$emit('submit', {
          ...this.form,
          headquartersShort: selectHeadquarters.headquartersShort,
        });
      }
    },
  },
  created() {
    this.form = { ...this.formFieldsDefault };
  },
};
</script>

<style></style>
